export default "__VITE_ASSET__2379cfb8__"